import { IconButton } from '@material-ui/core';
import { AddICon, CloseIcon, SaveIcon } from 'app/assets/images/icons';
import { useModal } from 'app/context/Modal';
import { checkTranslated } from 'app/utils/helpers';
import { _t } from 'app/utils/i18n';
import { updateHashtagWords } from 'hashtags/Requests';
import React, { FunctionComponent, useState } from 'react';
import { useMutation } from 'react-query';
import ReactSelectAutocomplete from '../Form/Inputs/ReactSelectAutocomplete';
import TextInput from '../Form/Inputs/TextInput';
import Loader from '../Loader';
import styles from './TweetReportPopup.module.scss';
import { handleLongString } from 'app/utils/stringMethods';
import { storeInfluencerSentiment } from 'influencers/Requests';
import { tweetSentimentAnalysisAdd } from 'tweets/Requests';
import {
  getYoutubeSentimentAnalysisAdd,
  instagramSentimentAnalysisAdd,
  linkedinSentimentAnalysisAdd,
  postTwitterSentimentAnalysisAdd,
  tiktokSentimentAnalysisAdd,
} from 'posts/Requests';
import { apiRoutes } from 'posts/utils/apiRoutes';
import { useLocation, useParams } from 'react-router-dom';

type TSectionContent = {
  id: number;
  title: string;
  wordList: any[];
  placeholder: string;
  value: string;
  error: string;
};
interface Props {
  pageContent: any;
  handleClosePopup: () => void;
  isOpen: boolean;
  handleDrag: () => void;
  tweetContent: any;
  destination?: string;
  handleOpenPopup: any;
  influencerId?: number;
  handleInfAutoComplete?: { customFilters: any };
  setColsKey?: any;
  tabName?: string;
  customFilters?: any;
  hashtagDetails?: any;
  hashtagsAutoCompleteEndPoint?: string;
  isPostTwitter?: boolean;
}

const TweetReportPopup: FunctionComponent<Props> = ({
  pageContent,
  isOpen,
  handleClosePopup,
  handleDrag,
  tweetContent,
  destination,
  handleOpenPopup,
  influencerId,
  handleInfAutoComplete,
  setColsKey,
  tabName,
  customFilters,
  hashtagsAutoCompleteEndPoint,
  isPostTwitter,
}) => {
  const initInputs: TSectionContent[] = [
    {
      id: 0,
      title: 'negative',
      wordList: [],
      placeholder: 'Add_negative_words',
      value: '',
      error: '',
    },
    {
      id: 1,
      title: 'neutral',
      wordList: [],
      placeholder: 'Add_neutral_words',
      value: '',
      error: '',
    },
    {
      id: 2,
      title: 'positive',
      wordList: [],
      placeholder: 'Add_positive_words',
      value: '',
      error: '',
    },
  ];
  const [sectionContent, setSectionContent] =
    useState<TSectionContent[]>(initInputs);
  const [isNotValid, setIsNotValid] = useState(false);
  const [wordValidError, setWordValidError] = useState(false);
  const [hashtag, setHashtag] = useState('');
  const { show, hide } = useModal();
  const checkWords: any = [];
  sectionContent.map((item: any) => {
    item?.wordList?.map((word: any) => {
      checkWords.push({
        word: word.word,
        word_category: word.word_category,
      });
    });
  });
  const handleClick = (value: string, id: number) => {
    if (value?.trim()?.length > 1 && value?.trim()?.length <= 150) {
      const addNewValue = (
        words: Array<{ itemId: number; word: string; word_category: string }>,
        title: string,
      ) => {
        const wordId =
          words.length === 0 ? 1 : words[words.length - 1].itemId + 1;
        if (words.some((item) => item.word === value)) {
          return words;
        } else {
          return [
            ...words,
            {
              itemId: wordId,
              word: value,
              word_category: title?.toUpperCase(),
            },
          ];
        }
      };
      setSectionContent((old) =>
        old.map((item) =>
          item.id === id
            ? {
                ...item,
                value: '',
                wordList: addNewValue(item.wordList, item.title),
              }
            : item,
        ),
      );
      setIsNotValid(false);
    } else if (value?.trim()?.length > 150) {
      setIsNotValid(true);
      setSectionContent((old) =>
        old.map((item) =>
          item.id === id
            ? {
                ...item,
                error: _t('basic:word_validation_max'),
              }
            : item,
        ),
      );
    } else {
      setIsNotValid(true);
      setSectionContent((old) =>
        old.map((item) =>
          item.id === id
            ? {
                ...item,
                error: _t('basic:word_validation_min'),
              }
            : item,
        ),
      );
    }
  };

  const handleChange = (value: string, id: number) => {
    setIsNotValid(false);
    setSectionContent((old) =>
      old.map((item) => (item.id === id ? { ...item, value } : item)),
    );
  };
  const {
    mutateAsync: influencerSentimentWordsMutation,
    isLoading: inFluLoading,
  } = useMutation({
    mutationFn: storeInfluencerSentiment,
    onSuccess: () => {
      show({
        message: `${_t('hashtags:grabbing_sentiment_analysis')} (${
          pageContent?.name?.original ||
          pageContent?.username ||
          pageContent?.channel_name
        }) ${_t('basic:you_will_be_notified')}`,
        onOk: () => {
          hide();
          handleDrag();
        },
        onOkText: _t('basic:ok'),
        hideCancel: true,
      });
      setColsKey?.((old: string) => old + 1);
    },
    onError: (err: any) => {
      if (err.response?.data?.code === 401) {
        handleClosePopup();
        show({
          isAlternative: true,
          message: err.response?.data?.message,
        });
        return;
      }
      setWordValidError(true);
    },
  });

  const {
    mutateAsync: tiktokSentimentWordsMutation,
    isLoading: isTiktokLoading,
  } = useMutation({
    mutationFn: tiktokSentimentAnalysisAdd,
    onSuccess: () => {
      show({
        message: `${_t('hashtags:grabbing_sentiment_analysis')}(${handleLongString(
          pageContent?.remote_id,
        )}) ${_t('basic:you_will_be_notified')}`,
        onOk: () => {
          hide();
          handleDrag();
        },
        onOkText: _t('basic:ok'),
        hideCancel: true,
      });
      setColsKey?.((old: string) => old + 1);
    },
    onError: (err: any) => {
      if (err.response?.data?.code === 401) {
        handleClosePopup();
        show({
          isAlternative: true,
          message: err.response?.data?.message,
        });
        return;
      }
      setWordValidError(true);
    },
  });
  const {
    mutateAsync: linkedinSentimentWordsMutation,
    isLoading: isLinkedinLoading,
  } = useMutation({
    mutationFn: linkedinSentimentAnalysisAdd,
    onSuccess: () => {
      show({
        message: `${_t('hashtags:grabbing_sentiment_analysis')}(${handleLongString(
          pageContent?.post_remote_id,
        )}) ${_t('basic:you_will_be_notified')}`,
        onOk: () => {
          hide();
          handleDrag();
        },
        onOkText: _t('basic:ok'),
        hideCancel: true,
      });
      setColsKey?.((old: string) => old + 1);
    },
    onError: (err: any) => {
      if (err.response?.data?.code === 401) {
        handleClosePopup();
        show({
          isAlternative: true,
          message: err.response?.data?.message,
        });
        return;
      }
      setWordValidError(true);
    },
  });
  const {
    mutateAsync: instagramSentimentWordsMutation,
    isLoading: isInstagramLoading,
  } = useMutation({
    mutationFn: instagramSentimentAnalysisAdd,
    onSuccess: () => {
      show({
        message: `${_t('hashtags:grabbing_sentiment_analysis')}(${handleLongString(
          pageContent?.post_code,
        )}) ${_t('basic:you_will_be_notified')}`,
        onOk: () => {
          hide();
          handleDrag();
        },
        onOkText: _t('basic:ok'),
        hideCancel: true,
      });
      setColsKey?.((old: string) => old + 1);
    },
    onError: (err: any) => {
      if (err.response?.data?.code === 401) {
        handleClosePopup();
        show({
          isAlternative: true,
          message: err.response?.data?.message,
        });
        return;
      }
      setWordValidError(true);
    },
  });

  const {
    mutateAsync: tweetSentimentWordsMutation,
    isLoading: isTweetLoading,
  } = useMutation({
    mutationFn: isPostTwitter
      ? postTwitterSentimentAnalysisAdd
      : tweetSentimentAnalysisAdd,
    onSuccess: () => {
      show({
        message: `${_t('hashtags:grabbing_sentiment_analysis')} (${handleLongString(
          pageContent?.remote_id,
        )}) ${_t('basic:you_will_be_notified')}`,
        onOk: () => {
          hide();
          handleDrag();
        },
        onOkText: _t('basic:ok'),
        hideCancel: true,
      });
      setColsKey?.((old: string) => old + 1);
    },
    onError: (err: any) => {
      if (err.response?.data?.code === 401) {
        handleClosePopup();
        show({
          isAlternative: true,
          message: err.response?.data?.message,
        });
        return;
      }
      setWordValidError(true);
    },
  });
  const {
    mutateAsync: youtubeSentimentWordsMutation,
    isLoading: isYoutubeLoading,
  } = useMutation({
    mutationFn: getYoutubeSentimentAnalysisAdd,
    onSuccess: () => {
      show({
        message: `${_t('hashtags:grabbing_sentiment_analysis')} (${handleLongString(
          pageContent?.remote_id,
        )}) ${_t('basic:you_will_be_notified')}`,
        onOk: () => {
          hide();
          handleDrag();
        },
        onOkText: _t('basic:ok'),
        hideCancel: true,
      });
      setColsKey?.((old: string) => old + 1);
    },
    onError: (err: any) => {
      if (err.response?.data?.code === 401) {
        handleClosePopup();
        show({
          isAlternative: true,
          message: err.response?.data?.message,
        });
        return;
      }
      setWordValidError(true);
    },
  });
  const { mutateAsync: updateHashtagMutation, isLoading } = useMutation(
    updateHashtagWords,
    {
      onError: (err: any) => {
        if (err.response?.data?.code === 401) {
          handleClosePopup();
          show({
            isAlternative: true,
            message: err.response?.data?.message,
          });
          return;
        }
        setWordValidError(true);
      },
      onSuccess: () => {
        show({
          message: `${_t(
            'hashtags:grabbing_sentiment_analysis',
          )} (${handleLongString(hashtagName)}) ${_t(
            'basic:you_will_be_notified',
          )}`,
          onOk: () => {
            hide();
            handleDrag();
          },
          onOkText: _t('basic:ok'),
          hideCancel: true,
        });
        setColsKey?.((old: string) => old + 1);
      },
    },
  );

  const id = pageContent?.id;
  const hashtagName = pageContent?.hashtag_name;
  const set_ids: any = [];
  const handleSubmit = async () => {
    const words: any = [];
    sectionContent.map((item: any) => {
      if (item.wordList.length > 0) {
        item?.wordList?.map((word: any) => {
          words.push({
            word: word.word,
            word_category: word.word_category,
          });
        });
      }
    });
    if (tabName === 'QUOTES' || tabName === 'REPLIES') {
      tweetSentimentWordsMutation({
        words: words?.map((word: any) => word.word),
        category: words[0]?.word_category,
        ...customFilters,
      }).then((res: any) => {
        if (!res.error && words.length !== 0) {
          setSectionContent(initInputs);
          handleClosePopup();
        } else {
          handleOpenPopup();
        }
      });
    }
    if (tabName === 'COMMENTS' && pageContent?.icon === 'Instagram') {
      instagramSentimentWordsMutation({
        words: words?.map((word: any) => word.word),
        category: words[0]?.word_category,
        ...customFilters,
      }).then((res: any) => {
        if (!res.error && words.length !== 0) {
          setSectionContent(initInputs);
          handleClosePopup();
        } else {
          handleOpenPopup();
        }
      });
    }
    if (pageContent?.icon === 'Tiktok' && tabName === 'COMMENTS') {
      tiktokSentimentWordsMutation({
        words: words?.map((word: any) => word.word),
        category: words[0]?.word_category,
        ...customFilters,
      }).then((res: any) => {
        if (!res.error && words.length !== 0) {
          setSectionContent(initInputs);
          handleClosePopup();
        } else {
          handleOpenPopup();
        }
      });
    }
    if (pageContent?.icon === 'Youtube' && tabName === 'COMMENTS') {
      youtubeSentimentWordsMutation({
        words: words?.map((word: any) => word.word),
        category: words[0]?.word_category,
        ...customFilters,
      }).then((res: any) => {
        if (!res.error && words.length !== 0) {
          setSectionContent(initInputs);
          handleClosePopup();
        } else {
          handleOpenPopup();
        }
      });
    }

    if (pageContent?.icon === 'Linkedin' && tabName === 'COMMENTS') {
      linkedinSentimentWordsMutation({
        words: words?.map((word: any) => word.word),
        category: words[0]?.word_category,
        ...customFilters,
      }).then((res: any) => {
        if (!res.error && words.length !== 0) {
          setSectionContent(initInputs);
          handleClosePopup();
        } else {
          handleOpenPopup();
        }
      });
    }

    if (
      !!influencerId &&
      tabName !== 'QUOTES' &&
      tabName !== 'REPLIES' &&
      tabName !== 'COMMENTS'
    ) {
      influencerSentimentWordsMutation({
        words: words?.map((word: any) => word.word),
        category: words[0]?.word_category,
        influencer_id: influencerId,
      }).then((res: any) => {
        if (!res.error && words.length !== 0) {
          setSectionContent(initInputs);
          handleClosePopup();
        } else {
          handleOpenPopup();
        }
      });
      return;
    }

    if (
      tabName !== 'QUOTES' &&
      tabName !== 'REPLIES' &&
      tabName !== 'COMMENTS'
    ) {
      updateHashtagMutation({
        id,
        hashtagName,
        set_ids,
        words,
      }).then((res: any) => {
        if (!res.error) {
          setSectionContent(initInputs);
          handleClosePopup();
        } else {
          handleOpenPopup();
        }
      });
    }
  };

  const tweetName = checkTranslated(
    tweetContent?.[0]?.influencer?.name?.original,
    tweetContent?.[0]?.influencer?.name?.arabic,
  );

  const handleSubmitWithoutWords = async () => {
    show({
      message: `${_t('hashtags:grabbing_sentiment_analysis')} (${
        handleLongString(hashtagName) ||
        tweetName ||
        tweetContent?.[0]?.username ||
        tweetContent?.[0]?.channel_name
      })  ${_t('basic:you_will_be_notified')}`,
      onOk: () => {
        hide();
      },
      onOkText: _t('basic:ok'),
      hideCancel: true,
    });
    setSectionContent(initInputs);
    handleClosePopup();
  };
  const removeWord = (id: number, itemId: number) => {
    setSectionContent((old) =>
      old.map((item) =>
        item.id === id
          ? {
              ...item,
              wordList: item.wordList.filter((item) => {
                return itemId !== item.itemId;
              }),
            }
          : item,
      ),
    );
    setWordValidError(false);
  };

  return (
    <div
      className={`${styles.TweetReport} ${!isOpen ? styles.Hidden : ''}`}
      data-testid="TweetReportPopup-testid"
    >
      <div className={styles.TweetReportPopup}>
        <div className={styles.TweetParent}>
          <div className={styles.header}>
            <h3>{_t('hashtags:selected_worlds')}</h3>
            <div className="Controls">
              <IconButton
                onClick={
                  /*    !checkWords.length ? handleSubmitWithoutWords : */ handleSubmit
                }
                data-testid="submit-holder"
              >
                {isLoading ||
                inFluLoading ||
                isTweetLoading ||
                isYoutubeLoading ||
                isTiktokLoading ||
                isLinkedinLoading ||
                isInstagramLoading ? (
                  <Loader smallSize />
                ) : (
                  <SaveIcon />
                )}
              </IconButton>
              <IconButton
                className={
                  isLoading ||
                  inFluLoading ||
                  isTweetLoading ||
                  isTiktokLoading ||
                  isInstagramLoading
                    ? styles.dimmedButton
                    : ''
                }
                onClick={() => {
                  handleClosePopup();
                  setSectionContent(initInputs);
                }}
                data-testid="close-holder"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <p className={styles.description}>
            {tweetContent[0]?.icon === 'Linkedin'
              ? checkTranslated(
                  tweetContent[0]?.post?.original ||
                    tweetContent[0]?.text?.original,
                  tweetContent[0]?.post?.arabic ||
                    tweetContent[0]?.text?.arabic,
                )
              : typeof tweetContent[0]?.content === 'string'
                ? checkTranslated(
                    tweetContent[0]?.content,
                    tweetContent[0]?.content_translated,
                  )
                : checkTranslated(
                    tweetContent[0]?.content?.original,
                    tweetContent[0]?.content?.arabic,
                  ) ||
                  checkTranslated(
                    tweetContent[0]?.title?.original,
                    tweetContent[0]?.title?.arabic,
                  ) ||
                  checkTranslated(
                    tweetContent[0]?.title,
                    tweetContent[0]?.title_translated,
                  ) ||
                  checkTranslated(
                    tweetContent[0]?.caption?.original,
                    tweetContent[0]?.caption?.arabic,
                  ) ||
                  checkTranslated(
                    tweetContent[0]?.text?.original,
                    tweetContent[0]?.text?.arabic,
                  )}
          </p>
          {sectionContent?.map(
            ({
              title,
              placeholder,
              wordList,
              value,
              id,
              error,
            }: TSectionContent) =>
              destination === title ? (
                <div className={styles.wrapper} key={title}>
                  {wordValidError && sectionContent?.[id]?.wordList?.length ? (
                    <p style={{ color: '#ff1c00' }}>
                      {_t('hashtags:this_Word_already')}
                    </p>
                  ) : (
                    ''
                  )}
                  <div className={styles.actionBox}>
                    <div
                      data-testid={`${title}-testid`}
                      className={
                        title === 'negative'
                          ? styles.negativeIcon
                          : title === 'neutral'
                            ? styles.neutralIcon
                            : styles.positiveIcon
                      }
                    />
                    <h3>{_t(`hashtags:${title}`)}</h3>
                  </div>
                  <div className={styles.wordBox}>
                    {wordList?.map((item, index) => (
                      <div
                        key={index}
                        className={styles.wordContent}
                        data-testid="wordContent-testid"
                      >
                        <span>{item?.word}</span>
                        <IconButton
                          data-testid="remove-word"
                          style={{ padding: '0' }}
                          onClick={() => removeWord(id, item.itemId)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    ))}
                  </div>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleClick(value, id);
                    }}
                    className={styles.TextInputBox}
                  >
                    <TextInput
                      label=" "
                      placeholder={_t(`hashtags:${placeholder}`)}
                      onChange={(value: string) => handleChange(value, id)}
                      value={value}
                      name="word"
                      error={isNotValid && error}
                    />

                    <IconButton
                      type="submit"
                      className={styles.AddButton}
                      data-testid="AddButton-TweetPopup"
                    >
                      <AddICon />
                    </IconButton>
                  </form>
                  {handleInfAutoComplete && (
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleClick(`#${hashtag}`, id);
                        setHashtag('');
                      }}
                      className={styles.TextInputBox}
                    >
                      <ReactSelectAutocomplete
                        size={'large'}
                        customWidth={'427px'}
                        placeholder={`${_t('hashtags:search_for')} ${_t(
                          `hashtags:${title}`,
                        )}  ${_t('hashtags:hashtags')}`}
                        moduleName={hashtagsAutoCompleteEndPoint}
                        value={hashtag === '' ? undefined : { label: hashtag }}
                        customFilters={customFilters}
                        onChange={(val: any) => {
                          setHashtag(val?.name || '');
                        }}
                      />

                      <IconButton
                        type="submit"
                        className={styles.AddButton}
                        data-testid="AddButton-TweetPopup"
                      >
                        <AddICon />
                      </IconButton>
                    </form>
                  )}
                </div>
              ) : null,
          )}
        </div>
      </div>
    </div>
  );
};

export default TweetReportPopup;
